import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);

  async signIn(token: string): Promise<void> {
    await firstValueFrom(this.http.post<void>('/api/mortgage-seller/sign-in-with-handoff-token', null, { headers: { Authorization: `Basic ${token}` } }));
  }
}
